
export default function Products() {
  const products = [
    {
      id: 1,
      name: 'VPN Application',
      description: 'Secure your online presence with our advanced VPN solution. Protect your privacy, encrypt your data, and access content from anywhere in the world with military-grade encryption and lightning-fast connection speeds.',
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/92e70e6837c5124df9a9607c1fd50e24.jpg',
      features: ['Military-grade encryption', 'Global server network', 'No-logs policy', 'Fast connection speeds']
    },
    {
      id: 2,
      name: 'Cleaner Application',
      description: 'Optimize your iOS device performance with our intelligent cleaner app. Remove junk files, manage storage efficiently, and keep your device running smoothly with advanced cleaning algorithms and user-friendly interface.',
      icon: 'ri-brush-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20application%20interface%20on%20iPhone%20screen%20showing%20storage%20optimization%20and%20cleaning%20features%2C%20minimalist%20design%20with%20teal%20accent%20colors%2C%20clean%20professional%20look%20with%20simple%20background%2C%20high%20quality%20product%20photography&width=600&height=700&seq=cleaner-product-001&orientation=portrait',
      features: ['Smart storage analysis', 'Junk file removal', 'Photo optimization', 'Battery management']
    }
  ];

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-gray-50 to-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Products</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our suite of iOS applications designed to enhance your mobile experience and protect your digital life
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300" data-product-shop>
              <div className="w-full h-80">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mr-4">
                    <i className={`${product.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">{product.name}</h3>
                </div>
                <p className="text-base text-gray-700 mb-6 leading-relaxed">
                  {product.description}
                </p>
                <div className="space-y-2">
                  {product.features.map((feature, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
